import type { IGetHolidayList, IPayloadHoliday } from '@/types/Request'

import type { IHoliday } from '@/types/Data'
import BaseService from '../BaseService'

export default class HolidayServices extends BaseService {
  GetHolidayList(payload: IGetHolidayList) {
    return this.GET<IHoliday[]>(this.PATHS.GET_HOLIDAY_LIST, payload)
  }

  CreateHoliday(data: IPayloadHoliday) {
    return this.POST<IHoliday>(this.PATHS.CREATE_HOLIDAY, data)
  }

  UpdateHoliday(data: IPayloadHoliday) {
    return this.PUT<IHoliday>(this.PATHS.UPDATE_HOLIDAY, data)
  }

  DeleteHoliday(Id: string) {
    return this.DELETE<boolean>(this.PATHS.DELETE_HOLIDAY, { Id })
  }
}
